import React from 'react';
import { CurrencyInput, PercentInput } from '../../../utils/FormInputs';

/**
 * SectionVariablesArt - Componente para las variables técnicas de ART.
 * Utiliza los componentes atómicos centralizados para consistencia y simplificación drástica de código.
 */
const SectionVariablesArt = ({ state, actions }) => {
    const { formData } = state;
    const { setFormData, handleChange, handleCurrencyChange, handlePercentChange } = actions;

    return (
        <fieldset className="border border-orange-200 rounded-xl p-6 bg-orange-50/20 text-left shadow-sm animate-fade-in transition-all duration-300">
            <legend className="px-3 text-lg font-bold text-orange-600">Variables del Contrato (ART)</legend>
            
            <div className="grid grid-cols-1 md:grid-cols-4 gap-6 pt-2">
                
                {/* 1. CIIU (ACTIVIDAD) */}
                <div>
                    <label className="label-form text-slate-500 font-bold mb-1 block">CIIU (Actividad)</label>
                    <input 
                        type="text" 
                        name="ciiu" 
                        value={formData.ciiu || ''} 
                        onChange={(e) => setFormData(p => ({...p, ciiu: e.target.value.replace(/\D/g, '')}))} 
                        className="input-round font-mono font-bold border-slate-200 focus:border-orange-400 text-slate-700 w-full rounded-xl px-4 py-2.5 h-[46px] outline-none border transition-all" 
                        placeholder="Solo números" 
                    />
                </div>

                {/* 2. CÁPITAS */}
                <div>
                    <label className="label-form text-slate-500 font-bold mb-1 block">Cápitas</label>
                    <input 
                        type="number" 
                        name="capitas" 
                        value={formData.capitas || ''} 
                        onChange={handleChange} 
                        className="input-round font-mono font-bold border-slate-200 focus:border-orange-400 text-slate-700 text-center w-full rounded-xl px-4 py-2.5 h-[46px] outline-none border transition-all" 
                        placeholder="0" 
                    />
                </div>

                {/* 3. MASA SALARIAL (Atómico) */}
                <CurrencyInput 
                    label="Masa Salarial"
                    value={formData.masaSalarial}
                    onChange={(e) => handleCurrencyChange(e, 'masaSalarial')}
                    placeholder="0,00"
                    focusColor="focus-within:border-orange-400 focus-within:ring-1 focus-within:ring-orange-100"
                />

                {/* 4. ALÍCUOTA (Atómico) */}
                <PercentInput 
                    label="Alícuota"
                    name="alicuota"
                    value={formData.alicuota}
                    onChange={handlePercentChange}
                    placeholder="0,00"
                    textColor="text-slate-700"
                    focusColor="focus-within:border-orange-400 focus-within:ring-1 focus-within:ring-orange-100"
                />

            </div>
        </fieldset>
    );
};

export default SectionVariablesArt;